import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

import { Button } from 'primereact/button';

import { Card } from 'primereact/card';

import Bac from './dialogs/bac.js';
import Dut from './dialogs/dut.js';
import Licence from './dialogs/licence.js';
import Master from './dialogs/master.js';

import bacImg from "../../../../../assets/bac.png";
import dutImg from "../../../../../assets/dut.png";
import licenceImg from "../../../../../assets/licence.png";
import masterImg from "../../../../../assets/master.png";

import './studies.css'

export default function Studies() {

    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    const [bacVisible, setBacVisible] = useState(false);
    const [dutVisible, setDutVisible] = useState(false);
    const [licenceVisible, setLicenceVisible] = useState(false);
    const [masterVisible, setMasterVisible] = useState(false);

    return (
        <>
            <div className="back-container-white pt-1 relative pb-6">
                <h2 className="text-center titles text-pink-200">{t("studies")}</h2>
                
                <div className="flex justify-content-center w-full">
                    <div className="grid xl:w-8 lg:w-10">
                        <div className="lg:col-3 col-6 flex justify-content-center">
                            <Card className="studies-card border-orange-700 shadow-orange-700 cursor-pointer" onClick={() => setBacVisible(true)}>
                                <div className="flex flex-column justify-content-between h-full"> 
                                    <div>
                                        <div className="w-full flex justify-content-center">
                                            <img src={bacImg} alt="BAC STI2D" width="80" height="50"/>
                                        </div>
                                        <h3 className="text-center mb-0 mt-2">{t("bac")}</h3>
                                        <h4 className="text-center mt-0">STI2D</h4>

                                        <p className="text-center">{t("lyceeRiquet")}</p>
                                    </div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="mt-3 border-orange-700 text-orange-700 border-2" onClick={() => setBacVisible(true)} outlined/>
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className="lg:col-3 col-6 flex justify-content-center">
                            <Card className="studies-card border-bluegray-400 shadow-bluegray-400 cursor-pointer" onClick={() => setDutVisible(true)}>
                                <div className="flex flex-column justify-content-between h-full"> 
                                    <div>
                                        <div className="w-full flex justify-content-center">
                                            <img src={dutImg} alt="DUT Informatique" width="80" height="50"/>
                                        </div>
                                        <h3 className="text-center mb-0 mt-2">{t("dut")}</h3>
                                        <h4 className="text-center mt-0">{currentLang === "fr" ? "Informatique" : ""}</h4>

                                        <p className="text-center">{t("paulSabatier")}</p>
                                    </div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="mt-3 border-bluegray-400 text-bluegray-400 border-2" onClick={() => setDutVisible(true)} outlined/>
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className="lg:col-3 col-6 flex justify-content-center">
                            <Card className="studies-card border-yellow-500 shadow-yellow-500 cursor-pointer" onClick={() => setLicenceVisible(true)}>
                                <div className="flex flex-column justify-content-between h-full"> 
                                    <div>
                                        <div className="w-full flex justify-content-center">
                                            <img src={licenceImg} alt="Licence MIASHS" width="80" height="50"/>
                                        </div>
                                        <h3 className="text-center mb-0 mt-2">{t("licence")}</h3>
                                        <h4 className="text-center mt-0">MIASHS</h4>

                                        <p className="text-center">{t("jeanJaures")}</p>
                                    </div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="mt-3 border-yellow-500 text-yellow-500 border-2" onClick={() => setLicenceVisible(true)} outlined/>
                                    </div>
                                </div>
                            </Card>
                        </div>
                        <div className="lg:col-3 col-6 flex justify-content-center">
                            <Card className="studies-card border-green-400 shadow-green-500 cursor-pointer" onClick={() => setMasterVisible(true)}>
                                <div className="flex flex-column justify-content-between h-full"> 
                                    <div>
                                        <div className="w-full flex justify-content-center">
                                            <img src={masterImg} alt="Master Sciences du logiciel" width="80" height="50"/>
                                        </div>
                                        <h3 className="text-center mb-0 mt-2">{t("master")}</h3>
                                        <h4 className="text-center mt-0">Sciences du logiciel</h4>

                                        <p className="text-center">{t("paulSabatier")}</p>
                                    </div>

                                    <div className="w-full flex justify-content-center">
                                        <Button label="Details" className="mt-3 border-green-500 text-green-500 border-2" onClick={() => setMasterVisible(true)} outlined/>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
            <Bac visible={bacVisible} setVisible={setBacVisible}/>
            <Dut visible={dutVisible} setVisible={setDutVisible}/>
            <Licence visible={licenceVisible} setVisible={setLicenceVisible}/>
            <Master visible={masterVisible} setVisible={setMasterVisible}/>
        </>
    )

}